module.exports = __webpack_public_path__ + "static/media/suggestions.56d6cfb2.webp";


//////////////////
// WEBPACK FOOTER
// ./src/containers/StartPages/images/suggestions.webp
// module id = 267
// module chunks = 1